<template>
  <div id="app">
    <!-- 正常宽度 -->
    <div class="header_pc" v-if="sizeType === 'pc'">
      <div class="logo">
        <img src="/icon.png" alt="">
        <span>微未云-连锁企业数字化管家</span>
      </div>
      <div class="nav">
        <div v-for="(item, index) in navList" :key="index"
          :style="{ color: (index === selectNav || index === currentNav) ? 'white' : '' }" @click="switchNav(index)">{{
            item
          }}</div>
      </div>
      <a-dropdown>
        <a class="login" @click="e => e.preventDefault()">
          企业登录
        </a>
        <a-menu slot="overlay">
          <a-menu-item>
            <a class="login" href="https://console.wefuture.org.cn" target="_blank">企业登录</a>
          </a-menu-item>
          <a-menu-item>
            <a class="login" href="https://srm.wefuture.org.cn" target="_blank">供应商登录</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <!-- 中等宽度 -->
    <div class="header_pad" v-if="sizeType === 'pad'">
      <div class="header-top">
        <div class="logo">
          <img src="/icon.png" alt="">
          <span>微未云-连锁企业数字化管家</span>
        </div>
        <a class="login" href="https://console.wefuture.org.cn" target="_blank">企业登录</a>
      </div>
      <div class="nav">
        <div v-for="(item, index) in navList" :key="index"
          :style="{ color: (index === selectNav || index === currentNav) ? 'white' : '' }" @click="switchNav(index)">{{
            item
          }}</div>
      </div>
    </div>
    <!-- 手机宽度 -->
    <div class="header_phone" v-if="sizeType === 'phone'">
      <div class="header-top">
        <div class="logo">
          <img src="/icon.png" alt="">
        </div>
        <img class="more" src="/more.png" alt="" @click="(() => { showNav = !showNav })">
      </div>
      <div class="nav" :style="{ height: showNav ? '200px' : '0px' }">
        <div v-for="(item, index) in navList" :key="index"
          :style="{ color: (index === selectNav || index === currentNav) ? 'white' : '' }" @click="switchNav(index)">{{
            item
          }}</div>
      </div>
    </div>
    <div class="body">
      <homeCard ref="homeCard" />
      <secondCard ref="secondCard" />
      <thirdCard ref="thirdCard" />
      <fourthCard ref="fourthCard" />
      <contactCard ref="contactCard" />
    </div>
    <div class="footer">
      <div class="record">Copyright@ 2018 南京微未信息科技有限公司. All Rights Reserved. 
        <a target="_blank" href="https://beian.miit.gov.cn">苏ICP备18060340号-2</a>
        <span>&nbsp;</span>
        <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch">苏公网安备32010202011523号</a>
      </div>
    </div>
  </div>
</template>

<script>
import homeCard from './components/homeCard/homeCard.vue'
import secondCard from './components/secondCard/secondCard.vue'
import thirdCard from './components/thirdCard/thirdCard.vue'
import fourthCard from './components/fouthCard/fourthCard.vue'
import contactCard from './components/contactCard/contactCard.vue'

export default {
  name: 'App',
  components: {
    homeCard,
    secondCard,
    thirdCard,
    fourthCard,
    contactCard
  },
  data: () => {
    return {
      navList: ['首页', '解决方案', '应用中心', '产品优势', '联系我们'],
      selectNav: 0, // 选中的导航
      currentNav: 0, // 当前导航
      domPosition: [], // 卡片位置
      sizeType: 'pc', // header显示类别，根据宽度自适应
      showNav: false, // 是否显示nav
    }
  },
  mounted() {
    // 初始化监听
    this.initObserver()
    window.onresize = () => {
      this.switchsizeType(document.querySelector('html').offsetWidth)
    }

    this.switchsizeType(document.querySelector('html').offsetWidth)
  },
  methods: {
    // 监听卡片显示事件
    initObserver() {
      const cardList = ['homeCard', 'secondCard', 'thirdCard', 'fourthCard', 'contactCard']
      cardList.forEach((card) => {
        const dom = this.$refs[card].$el
        this.domPosition.push(dom.offsetTop)
      })

      document.addEventListener('scroll', () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        // 向下滚动
        for (let i = 0; i < this.domPosition.length; i++) {
          if (scrollTop <= this.domPosition[i]) {
            this.currentNav = i
            return
          }
        }
      })
    },
    // 切换导航
    switchNav(index) {
      this.showNav = false
      document.querySelector('html').scrollTo({
        top: this.domPosition[index] - 60,
        behavior: 'smooth'
      })
    },
    // 切换窗口尺寸
    switchsizeType(width) {
      if (width > 1100) {
        this.sizeType = 'pc'
      } else if (width > 500) {
        this.sizeType = 'pad'
      } else {
        this.sizeType = 'phone'
      }
    },
  }
}
</script>

<style lang="less" >
body {
  margin: 0;
  padding: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  font-size: 15px;

  .header_pc {
    height: 60px;
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    background-color: #1a2029;
    z-index: 1;
    position: fixed;
    top: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      display: flex;
      align-items: center;

      img {
        height: 40px;
        width: 40px;
        margin-right: 20px;
      }
    }

    .nav {
      height: 60px;
      display: flex;
      align-items: center;

      div {
        height: 100%;
        margin: 0 30px;
        cursor: pointer;
        font-size: 16px;
        color: #999;
        font-weight: 600;
        display: flex;
        align-items: center;
        padding: 0 10px;

        &:hover {
          border-bottom: 3px solid #fff;
          color: #fff;
        }
      }
    }

    .login {
      color: #fff;
      text-decoration: none;
    }
  }

  .header_pad {
    height: 120px;
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    background-color: #1a2029;
    z-index: 1;
    position: fixed;
    top: 0;
    color: #fff;
    display: flex;
    flex-direction: column;

    .header-top {
      height: 60px;
      display: flex;
      justify-content: space-between;

      .logo {
        display: flex;
        align-items: center;

        img {
          height: 40px;
          width: 40px;
          margin-right: 20px;
        }
      }

      .login {
        color: #fff;
        text-decoration: none;
        line-height: 60px;
      }
    }


    .nav {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        margin: 0 10px;
        cursor: pointer;
        font-size: 16px;
        color: #999;
        font-weight: 600;
        display: flex;
        align-items: center;
        padding: 0 10px;

        &:hover {
          border-bottom: 3px solid #fff;
          color: #fff;
        }
      }
    }

  }

  .header_phone {
    height: 60px;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    background-color: #1a2029;
    z-index: 1;
    position: fixed;
    top: 0;
    color: #fff;


    .header-top {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo {
        display: flex;
        align-items: center;

        img {
          height: 40px;
          width: 40px;
          margin-right: 20px;
        }
      }

      .more {
        height: 20px;
        width: 30px;
      }
    }


    .nav {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      width: 100%;
      overflow: hidden;
      left: 0;
      background-color: #1a2029;
      border-top: 1px solid #999;
      transition: height 0.5s;

      div {
        height: 40px;
        line-height: 40px;
        width: 100%;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        color: #999;
        font-weight: 600;

        &:hover {
          color: #fff;
        }
      }
    }

  }

  .body {
    padding-top: 60px;
  }

  .footer {

    .record {
      height: 50px;
      line-height: 50px;
      width: 100%;
      font-size: 14px;
      color: #ddd;
      background-color: #111;
      text-align: center;

      a {
        color: #666;
        text-decoration: none;
      }
    }
  }
}</style>
